var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsuario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2625 6.31732C25.2625 8.93363 23.1417 11.0546 20.5253 11.0546C19.9548 11.0546 19.4079 10.9537 18.9014 10.7689C19.6484 9.45494 20.0751 7.93507 20.0751 6.31557C20.0751 4.69725 19.6491 3.17844 18.9029 1.86517C19.409 1.68071 19.9554 1.58008 20.5253 1.58008C23.1417 1.58008 25.2625 3.70102 25.2625 6.31732Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 23.6869C30.0002 26.3032 26.786 28.424 22.8615 28.424C24.0177 27.1603 24.8128 25.5739 24.8128 23.689C24.8128 21.802 24.0158 20.2142 22.8574 18.9497C26.7819 18.9497 30.0002 21.0706 30.0002 23.6869Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0536 30.0042C17.1583 30.0042 22.1071 27.1763 22.1071 23.6879C22.1071 20.1995 17.1583 17.3716 11.0536 17.3716C4.94885 17.3716 0 20.1995 0 23.6879C0 27.1763 4.94885 30.0042 11.0536 30.0042Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0536 12.6326C14.542 12.6326 17.3699 9.80473 17.3699 6.31632C17.3699 2.82791 14.542 0 11.0536 0C7.56522 0 4.7373 2.82791 4.7373 6.31632C4.7373 9.80473 7.56522 12.6326 11.0536 12.6326Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.4091aef816ddf8ac1aa886d8ec0a955d.svg";
export { ForwardRef as ReactComponent };